import Camera from '../../src/legacy/Camera.tsx';
export default Camera;
